import React from 'react';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { DownloadSection, TrustSectionContainer } from './styled';

function TrustSection(props) {
  return (
    <TrustSectionContainer>
      {/* <AppVideo />
            <TrustInner>
                <ToolsSection>
                    <AnchorCoverTag
                        url={"/parenting"}
                        element={{ deeplinkValue: "/parenting?tools=true" }}
                    >
                        <img
                            src="https://images.myloapp.in/NestJsUploads/1697878729932-MicrosoftTeams-image-(5).webp"
                            alt=""
                        />
                    </AnchorCoverTag>
                </ToolsSection>
                <div className="joySection">
                    <OurPhilosophySection />
                </div>
            </TrustInner> */}
      <DownloadSection>
        <img
          className="mobileSection"
          src={
            'https://images.myloapp.in/NestJsUploads/1697827988661-Mask-Group-154754.webp'
          }
          style={{ width: '100%' }}
          alt=""
        />
        <AnchorCoverTag url="https://app.mylofamily.com/get_mylo_app?source=organic&campaign=website_home_page">
          <img
            className="mobileSection mobilebtnContainer"
            src="https://images.myloapp.in/NestJsUploads/1697804361622-iNSTALL-NOW-BUTTONS.webp"
            alt=""
          />
        </AnchorCoverTag>

        <img
          className="desktopSection"
          src={
            'https://images.myloapp.in/NestJsUploads/1697827988664-Mask-Group-154755.webp'
          }
          style={{ width: '100%' }}
          alt=""
        />

        <div className="btnContainer desktopSection">
          <AnchorCoverTag url="https://app.mylofamily.com/get_mylo_app?source=organic&campaign=website_home_page">
            <img
              src="https://images.myloapp.in/NestJsUploads/1697742584283-Get-on-g-play.webp"
              alt=""
            />
          </AnchorCoverTag>
          <AnchorCoverTag url="https://apps.apple.com/in/app/mylo-pregnancy-parenting-app/id1577492842">
            <img
              src="https://images.myloapp.in/NestJsUploads/1697742584283-app-store.webp"
              alt=""
            />
          </AnchorCoverTag>
        </div>
      </DownloadSection>
    </TrustSectionContainer>
  );
}

export default TrustSection;
